import { DetailsList, DetailsListLayoutMode, IDetailsListProps } from '@fluentui/react/lib/DetailsList';
import { IShimmeredDetailsListProps, ShimmeredDetailsList } from '@fluentui/react/lib/ShimmeredDetailsList';
import { useCallback } from 'react';

export interface IPShimmeredDetailsListProps extends IShimmeredDetailsListProps {}
export interface IPDetailsListProps extends IDetailsListProps {}
export { DetailsListLayoutMode as IPDetailsListLayoutMode };

export const IPDetailsList = (props: IPDetailsListProps) => {
  return <DetailsList {...props} />;
};

// While it shimmers, ShimmeredDetailsList gives DetailsList empty placeholder rows, and DetailsList calls getKey with an
// undefined item for them. The caller's getKey only sees real items: a placeholder is keyed by its index.
export const IPShimmeredDetailsList = (props: IPShimmeredDetailsListProps) => {
  const { getKey } = props;
  const getItemKey = useCallback<NonNullable<IShimmeredDetailsListProps['getKey']>>(
    (item, index) =>
      item === undefined || item === null ? `shimmer-${index ?? 0}` : getKey?.(item, index) ?? `${index ?? 0}`,
    [getKey],
  );

  return <ShimmeredDetailsList {...props} getKey={getKey ? getItemKey : undefined} />;
};
